import {z} from 'zod';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'delete-brand-context' as const;

const argumentZod = z.object({
  brandId: z.string().describe('The brand ID to archive.'),
});

export const deleteBrandContextManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Delete brand context',
  family: 'brand',
  llmTool: {
    name: toolName,
    description:
      'Soft-deletes a brand for the current site (from MCP session context) by setting its status to "archived". The brand data is retained but no longer active.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AEO_MEASUREMENT,
  confirmBeforeExecuting: true,
});

export type DeleteBrandContextArgumentType = z.infer<typeof argumentZod>;
